<template>
  <div class="container">
    <section
      v-for="(item, index) in list"
      :key="index"
      class="section"
      @click="toApp(item)"
    >
      <div class="item">
        <img class="img" :src="item.icon" alt="icon" />
        <span class="text-base">{{ item.title }}</span>
      </div>
      <img class="more" src="../assets/left-arrows.png" alt="" />
    </section>
    <!-- {{ $t("customer.dialog.wechat.needSupport") }} -->
  </div>
</template>

<script>
import {reactive, toRefs} from 'vue';
import getUrlQuery from '../utils/getUrlQuery';
import {useI18n} from 'vue-i18n';
import {Dialog} from 'vant';
import dsBridge from 'dsbridge';

import {getImageUrl, isIOS} from '..//utils/util';
// @ is an alias to /src

export default {
  name: 'CustomerService',
  setup() {
    const {t, locale} = useI18n();

    const state = reactive({
      list: [],
      // 海外客服
      overseasList: [
        // {
        //   name: 'facebook',
        //   title: 'Facebook Messenger',
        //   url: 'http://m.me/lavamusicofficial/',
        //   icon: require('../assets/Facebook Messenger.png'),
        //   analytics: 'Facebook Messenger',
        // },
        {
          name: 'whatsApp',
          title: 'service@lavamusic.com',
          url: 'mailto:service@lavamusic.com',
          icon: require('../assets/email.png'),
          analytics: 'WhatsApp',
        },
      ],
      // 国内客服
      domesticList: [
        {
          name: 'weChat',
          title: '微信',
          url: 'https://work.weixin.qq.com/kfid/kfc9b10d4e774c9f761',
          icon: require('../assets/Wechat.png'),
          analytics: '企业微信',
        },
      ],
    });
    const region = getUrlQuery('region');
    const lang = getUrlQuery('lang');

    if (lang === 'cn') {
      locale.value = 'cn';
    }
    state.list = state.overseasList; // 默认海外
    if (region === 'zh') {
      state.list = state.domesticList;
      if (lang === 'en') {
        state.domesticList[0].title = 'WeChat';
        state.list = state.domesticList;
      }
    }

    function saveImg(url) {
      dsBridge.call(
        'saveFileWithUrl',
        {
          type: 'image',
          url,
        },
        (res) => {
          console.log('saveFileWithUrl', res);
        }
      );
    }
    const dialogMassageTemplate = (msg) => {
      return () => (
        <div class="relative">
          {msg}
          <img
            onClick={() => Dialog.close()}
            src={getImageUrl('Union.png')}
            class="absolute"
          />
        </div>
      );
    };
    const dialogList = {
      weChat: {
        message: dialogMassageTemplate(
          <div class="dialog-container dialog-container-weChat">
            <p>{t('customer.dialog.wechat.needSupport')}</p>
            <img
              class="my-2 w-[120px] h-[120px]"
              src={getImageUrl('WechatQR.png')}
              alt="WechatQR"
            />
            <p class="text-[#666] text-xs">
              {t('customer.dialog.wechat.withWeChat')}
            </p>
          </div>
        ),
        confirmButtonText: t('customer.dialog.wechat.saveTheQR'),
        click: () => {
          saveImg('https://qn.lavamusic.com/qr/WechatQR.png');
        },
      },
      facebook: {
        message: dialogMassageTemplate(
          <div class="flex flex-col items-center text-base">
            <p class="mb-2 font-medium">
              {t('customer.dialog.facebook.needSupport')}
            </p>
            <p class="font-normal text-[#666] text-base">
              {t('customer.dialog.facebook.FacebookToContact')}
            </p>
          </div>
        ),
        confirmButtonText: t('customer.dialog.facebook.copyAccount'),
        click: () => {
          dsBridge.call(
            'copyToClipboard',
            {
              text: 'lavamusicofficail',
            },
            (res) => {
              console.log('copyToClipboard', res);
            }
          );
        },
      },
      whatsApp: {
        message: dialogMassageTemplate(
          <div class="dialog-container dialog-container-whatsApp">
            <p class="text-base">LAVA Support</p>
            <p class="text-xs text-[#999]">WhatsApp contact</p>
            <img
              class="my-2 w-[120px] h-[120px]"
              src={getImageUrl('WhatsAppQR.png')}
              alt="WhatsAppQR"
            />
            <p class="text-[#666] text-xs">
              {t('customer.dialog.whatsApp.needSupport')}
            </p>
          </div>
        ),
        confirmButtonText: t('customer.dialog.whatsApp.saveTheQR'),
        click: () => {
          saveImg('https://qn.lavamusic.com/qr/WhatsAppQR.png');
        },
      },
    };
    const toApp = (item) => {
      const {url, name, analytics} = item;
      const dialogItem = dialogList[name];
      // 类型为whatsApp不用以下弹窗的逻辑
      if (name !== 'whatsApp') {
        const time = setTimeout(() => {
          Dialog.alert({
            ...dialogItem,
            confirmButtonColor: '#000',
          }).then(() => {
            console.log('12312314123');
            dialogItem.click();
          });
        }, 1500);
        document.addEventListener('visibilitychange', () => {
          clearTimeout(time);
        });
        window.onhashchange = function () {
          clearTimeout(time);
        };
      }

      dsBridge.call('analytics', {
        event: 'customer_service_type',
        params: {CUSTOMER_SERVICE_TYPE: analytics},
      });
      if (isIOS()) {
        dsBridge.call('openAction', {pageType: 5, url});
      } else {
        if (/LAVA/.test(navigator.userAgent) || region === 'zh') {
          dsBridge.call('openAction', {pageType: 5, url});
          return;
        }
        window.location.href = url;
      }
    };
    return {
      ...toRefs(state),
      toApp,
    };
  },
};
</script>
<style lang="scss" scoped>
a {
  color: #000;
}
.container {
  padding-top: 10px;
  padding-left: 1rem;
  padding-right: 1rem;
  background-color: rgba(247, 247, 247, 1);
  height: 100%;
}
.section {
  padding: 0 0.75rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 0.5rem;
  justify-content: space-between;
  align-items: center;
  height: 72px;
  display: flex;
  margin-bottom: 1rem;
  .item {
    align-items: center;
    flex: 1 1 0%;
    display: flex;
    .img {
      border-radius: 0.375rem;
      width: 2.5rem;
      // height: 2.5rem;
      margin-right: 10px;
    }
    .text-base {
      font-size: 1rem;
      line-height: 1.5rem;
    }
  }
  .more {
    width: 6.5px;
  }
}
</style>
